import { useTranslation } from 'react-i18next'
import { demoPath } from '~/pages/help/demo/demo-path'
import DemoChapterPicker from '~/pages/help/demo/DemoChapterPicker'
import DemoModuleContent from '~/pages/help/demo/DemoModuleContent'
import PlayerFrame from '~/pages/scorm/components/PlayerFrame'
import PreviewHeader from '~/pages/scorm/components/PreviewHeader'
import PreviewNoTrackingNotice from '~/pages/scorm/components/PreviewNoTrackingNotice'

/** La prévisualisation d'un module, en démonstration (#105) : son vrai cadre, sans module. */
function PreviewDemo() {
  const { t } = useTranslation()

  return (
    <PlayerFrame
      fallbackTo="/back-office/modules"
      fallbackLabel={t('scorm.preview.backToModules')}
      headerContent={<PreviewHeader title={demoPath(t).modules?.find(step => step.module?.id === 'essentials')?.module?.title} />}
      headerRight={(
        <>
          <DemoChapterPicker />
          <PreviewNoTrackingNotice />
        </>
      )}
    >
      <DemoModuleContent backTo="/back-office/help" />
    </PlayerFrame>
  )
}

export default PreviewDemo
